import { SidebarTrigger } from "@/components/ui/sidebar";
import { Slash } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function TopBar() {
  const { t } = useTranslation();
  const location = useLocation();

  const PAGE_TITLES: Record<string, string> = {
    "/company-profile": t("topBar.pageCompanyProfile"),
    "/sales-outreach": t("topBar.pageSalesOutreach"),
    "/analyzed-companies": t("topBar.pageAnalyzedCompanies"),
    "/subscription": t("topBar.pageSubscription"),
    "/client-profile": t("topBar.pageMyProfile"),
  };

  const pageTitle = PAGE_TITLES[location.pathname] ?? "Easly";

  return (
    <header className="h-14 flex items-center border-b border-border/70 px-4 sticky top-0 z-40 backdrop-blur-xl bg-background/88">
      <div className="flex items-center gap-3">
        <SidebarTrigger className="text-muted-foreground hover:text-foreground transition-colors" />
        <div className="hidden sm:flex items-center gap-2.5 text-sm">
          <Slash className="w-3 h-3 text-border rotate-[-20deg]" />
          <span className="font-semibold font-display text-foreground tracking-tight">
            {pageTitle}
          </span>
        </div>
      </div>
    </header>
  );
}
